import { FC, Fragment } from 'react';

import AcceptConflictBold from '@/assets/icons/AcceptConflictBold';
import { defectIsBinnenPeriodeNietInzetbaar } from '@/domain/defecten/defect';
import { Conflict } from '@/types/Conflicten';
import { Defect } from '@/types/Defecten';

import usePlankTableStore from '../../hooks/usePlankTableStore';
import {
  geefInzetVoorConflict,
  geefStelOfOorspronkelijkDienstVoorConflict,
  geefStelOfOorspronkelijkDienstVoorMancoConflict,
  geefVerkeersdagTijdstipVoorElement,
  isVerkeersdagVandaag,
} from '../../utils/conflict';
import DefectIcon from '../defect/DefectIcon';
import NotitieRelatedItem from '../Notitie/NotitieRelatedItem';
import ReserveIcon from '../reserve/ReserveIcon';
import SidepanelToggle from '../Sidepanel/Toggle/SidepanelToggle';

import ConflictParts from './ConflictParts';

import cardStyles from '../Table/Table.module.css';
import styles from './Conflict.module.css';

type ConflictSidepanelType = {
  conflict: Conflict;
  relatedDefect?: Defect;
};
const ConflictSidepanel: FC<ConflictSidepanelType> = ({ conflict, relatedDefect = undefined }) => {
  const element = conflict.type === 'MANCO' ? geefInzetVoorConflict(conflict) : conflict.elementen[0];
  const oorspronkelijkeDienst =
    conflict.type === 'MANCO'
      ? geefStelOfOorspronkelijkDienstVoorMancoConflict(element)
      : geefStelOfOorspronkelijkDienstVoorConflict(conflict);
  const relatedReserve = usePlankTableStore(
    (state) => state.reserveByStel[String(geefStelOfOorspronkelijkDienstVoorConflict(conflict))],
  );
  const relatedNotitie = usePlankTableStore((state) => state.getConflictNotitie(conflict));

  return (
    <div className={cardStyles.cardStyleSidepanel}>
      <div className={styles.spConflictDivStyle}>
        <ConflictParts.Indicator conflictType={conflict.type} />
        <div className={styles.flex}>
          <div className={styles.flex}>
            <ConflictParts.Icon conflictType={conflict.type} />
            <div className={`${styles.conflictHeaderFlexStyle} ${styles[`conflictHeaderStyle--${conflict.type}`]}`}>
              {conflict?.lastAcceptedPerDay?.length ? (
                <>
                  {conflict.lastAcceptedPerDay.map((el, index) => (
                    <Fragment key={el.treinNummer}>
                      {index > 0 && <span style={{ padding: '0 3px 0 1px' }}> - </span>}
                      {el.uitvoeringstijd && !isVerkeersdagVandaag(el) && (
                        <span className={styles.lastAcceptedDayStyle}>
                          {geefVerkeersdagTijdstipVoorElement(el)}
                          {': '}
                        </span>
                      )}
                      <span>{conflict.type === 'MANCO' && el.oorspronkelijkeDienst}</span>
                      <span>
                        {(conflict.type === 'VERKEERD_MATERIEEL' || conflict.type === 'VERSTERKT_MATERIEEL') &&
                          geefStelOfOorspronkelijkDienstVoorConflict(conflict)}
                      </span>
                    </Fragment>
                  ))}
                  <AcceptConflictBold width={18} height={18} fill='var(--tractie-color-content-emphasis)' />
                </>
              ) : (
                oorspronkelijkeDienst
              )}
            </div>
            <ConflictParts.AssignedMat showRelatedDefect conflict={conflict} />
          </div>
          {relatedDefect && (
            <div>
              <SidepanelToggle
                data-testid={`relatedDefects${relatedDefect.eenheidNummer}`}
                activeStyle={false}
                eenheid={relatedDefect.eenheidNummer}
                defect={relatedDefect}
                className={styles.relatedDefectStyle}
              >
                <DefectIcon
                  defectSoort={relatedDefect.soort}
                  nietInzetbaarBinnen24Uur={defectIsBinnenPeriodeNietInzetbaar(relatedDefect)}
                />
              </SidepanelToggle>
            </div>
          )}
          {relatedReserve && (
            <div>
              <SidepanelToggle
                data-testid={`relatedDefects${relatedReserve.eenheid}`}
                activeStyle={false}
                eenheid={relatedReserve.eenheid}
                reserve={relatedReserve}
                className={styles.relatedReserveStyle}
              >
                <ReserveIcon fill='var(--tractie-color-background-default)' />
              </SidepanelToggle>
            </div>
          )}
          <div className={styles.spConflictToelichtingStyle}>
            {conflict.lastAcceptedPerDay?.length ? (
              <div className={styles.toelichtingStyle}>
                <span className={styles.toelichtingObliqueStyle}>
                  Alle inzetten binnen dit conflict zijn geaccepteerd
                </span>
              </div>
            ) : (
              <ConflictParts.Toelichting element={element} />
            )}
          </div>
          {!conflict?.lastAcceptedPerDay?.length && (
            <ConflictParts.OpvolgendeBijzonderheidscode conflict={conflict} huidigElement={element} />
          )}
        </div>
      </div>
      <NotitieRelatedItem notitie={relatedNotitie} />
    </div>
  );
};
export default ConflictSidepanel;
